import { render, staticRenderFns } from "./SendWithEmailModal.vue?vue&type=template&id=fd472f10"
import script from "./SendWithEmailModal.vue?vue&type=script&lang=js"
export * from "./SendWithEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports